import { BorderRadius, Color } from '@billy/design-system'
import styled from '@emotion/styled'

import { ToggleVisibilityWidgetButtonContainer } from '../../../../../ToggleVisibilityWidgetButton/styles'
import { getWidgetContainerStyles } from '../../../../utils/getWidgetContainerStyles'

interface HiddenWidgetContainerProps {
  isFullWidth?: boolean
}

export const HiddenWidgetContainer = styled.div<HiddenWidgetContainerProps>`
  grid-column: ${({ isFullWidth }) => getWidgetContainerStyles(isFullWidth)};
  border-radius: ${BorderRadius.R12};
  position: relative;
  box-shadow: 0 2px 1px ${Color.Grey150};

  & > *:not(${ToggleVisibilityWidgetButtonContainer}) {
    opacity: 0.5;
    pointer-events: none;
  }

  &:hover ${ToggleVisibilityWidgetButtonContainer} {
    visibility: visible;
    opacity: 1;
  }
`
